import styled from 'styled-components';

export const Content = styled.div`
  margin: 1.5rem 0 25px 0;
`;

export const IFrame = styled.iframe<{ height?: string }>`
  width: 100%;
  border: none;
  border-radius: 0.5rem;
  min-height: ${({ height }) => (height ? `${height}px` : '800px')};
`;
